package uz.ferro.erp.feature.text.ui

import react.FC
import react.Props
import uz.ferro.erp.feature.text.model.DocContent
import uz.ferro.erp.feature.text.model.DocItem
import uz.ferro.erp.feature.text.model.DocItemType
import uz.ferro.erp.feature.text.model.TextItem

external interface DocContentProps : Props {
    var content: DocContent
}

val DocContentView = FC<DocContentProps> { props ->
    val content = props.content
    if (content.items != null) {
        content.items.forEach {
            DocItemView {
                this.item = it
            }
        }
    } else if (content.text != null) {
        var type = DocItemType.TEXT
        var textItems: List<TextItem>? = null
        if (content.style != null) {
            type = DocItemType.FORMATTED_TEXT
            textItems = listOf(
                TextItem(
                    style = content.style,
                    text = content.text,
                )
            )
        }

        DocTextView {
            this.item = DocItem(
                type = type,
                text = content.text,
                textItems = textItems
            )
        }
    }
}